module.exports = __webpack_public_path__ + "c2f55ad5ac783bbb7e40cd0d212728d9.svg";